import { render, staticRenderFns } from "./Istoria.vue?vue&type=template&id=e5574140&scoped=true&"
import script from "./Istoria.vue?vue&type=script&lang=js&"
export * from "./Istoria.vue?vue&type=script&lang=js&"
import style0 from "./Istoria.vue?vue&type=style&index=0&id=e5574140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5574140",
  null
  
)

export default component.exports